import { NonNullableStringParameter, useAssignQueryParameter } from '@pba/react-router';
import { useMemo } from 'react';

export const useChangeRequestParams = () => {
  const { value: changeRequestId } = useAssignQueryParameter('chr', NonNullableStringParameter);

  return useMemo(
    () => ({
      changeRequestId,
    }),
    [changeRequestId],
  );
};
